
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SettingsType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetimeFormat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberFormat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"budgetUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dashboardNumberScale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dashboardNumberPrecision"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tableNumberScale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tableNumberPrecision"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":183}};
    doc.loc.source = {"body":"fragment SettingsFragment on SettingsType {\n  datetimeFormat\n  numberFormat\n  budgetUnit\n  dashboardNumberScale\n  dashboardNumberPrecision\n  tableNumberScale\n  tableNumberPrecision\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
